class SvgAnimate {
  constructor() {
    this.svgAnimate = $(".svg-viewport-hover")
    if (this.svgAnimate.length > 0) {
      this.load()
    }
  }

  load() {
    $(window).on(
      "DOMContentLoaded load resize scroll",
      this._handleViewportApparition()
    )
    this.svgAnimate.on("mouseenter", () => {
      const hoveredSvg = $("svg", this)

      hoveredSvg.removeClass("svg-animation-launched")

      setTimeout(() => {
        // Timeout is necessary to let the browser see the change
        hoveredSvg.addClass("svg-animation-launched")
      }, 50)
    })
  }

  _handleViewportApparition() {
    return this._onVisibilityChange(this.svgAnimate, el => {
      if (this._isElementInViewport(el)) {
        $("svg", el).addClass("svg-animation-launched")
      } else {
        $("svg", el).removeClass("svg-animation-launched")
      }
    })
  }

  _isElementInViewport(el) {
    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0]
    }

    const rect = el.getBoundingClientRect()

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight ||
          document.documentElement.clientHeight) /*or $(window).height() */ &&
      rect.right <=
        (window.innerWidth ||
          document.documentElement.clientWidth) /*or $(window).width() */
    )
  }

  _onVisibilityChange(els, callback) {
    let old_visible
    return () => {
      const self = this
      $.each(els, (index, el) => {
        const visible = self._isElementInViewport(el)
        if (visible != old_visible) {
          old_visible = visible
          if (typeof callback == "function") {
            callback(el)
          }
        }
      })
    }
  }
}

export { SvgAnimate }
